import React from "react";
import api from "./../../Api.js";
import classnames from "classnames";
import {Input,Modal,Card,CardHeader,Row,Col,Button,Table,UncontrolledTooltip,Tooltip,Container,CardBody,Form,Alert,FormGroup,InputGroup,InputGroupAddon,InputGroupText} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import { connect } from 'react-redux';
//import InputMask from 'react-input-mask';
import SimpleHeader from "./../../components/Headers/SimpleHeader.jsx";
import reduxHelper from "./../../helper/index.js";
import {BounceLoader,ClipLoader} from 'react-spinners';
import $ from 'jquery';
import moment from 'moment';
import UserDetailModal from "./modal/company/UserDetailModal.jsx";
import CompanyCoursesModal from "./modal/company/CompanyCoursesModal.jsx";
import AllCoursesModal from './modal/company/AllCoursesModal.jsx';
import CourseDetailModal from './modal/company/CourseDetailModal.jsx';
import RemoveCompanyModal from './modal/company/RemoveCompanyModal.jsx';
import CompanyCreateModal from './modal/company/CompanyCreateModal.jsx';
import AddUserCompanyModal from './modal/company/AddUserCompanyModal.jsx';
import UnitsModal from './modal/company/UnitsModal.jsx';

class Users extends React.Component {

    constructor(props){
        super(props);
  // cache local para evitar recomputação e requests repetidos por unidade
  this._companyCourseCache = new Map();
  this.state = {companys:[],dialog:{name:"",group:"",license:"",login_google: "0", user_limit: ""},erroCompany:"",addUserCompany:false,
   companySearch: "",
   companySearchInput: "",
  companysVersion: 0,
         coursesModalOpen: false,
         selectedCompany: null,
         courseDetails: [],
         courseStatsId: null,
         courseStatsName: "",
         courseDetailModalOpen: false,
         courseDetailData: null,
         courseDetailLoading: false,
         courseDetailShowStudents: false,
         courseDetailBackTarget: null,
         classParticipants: {},
         classParticipantsLoading: {},
         unitsModalOpen: false,
         unitsModalCourse: null,
         allCoursesModalOpen: false,
        isTyping: false
          ,
        courseSearchTerm: "",
        userDetailModalOpen: false,
        userDetailId: null
    ,tooltipOpen: false,
    tooltipTarget: null,
    tooltipData: null
    };
        this.helper = new reduxHelper(this.props);
        this.editCompany = this.editCompany.bind(this);
        this.newCompany = this.newCompany.bind(this);
        this.getAllcompany = this.getAllcompany.bind(this);
        this.deleteCompany = this.deleteCompany.bind(this);
        this.getDataUnidade = this.getDataUnidade.bind(this);
        this.addUserCompany = this.addUserCompany.bind(this);
        
        

        window.unidades = this;

  this.openModal = this.openModal.bind(this);
  this.closeModal = this.closeModal.bind(this);
  this.showTooltip = this.showTooltip.bind(this);
  this.hideTooltip = this.hideTooltip.bind(this);

    }

  debounce(key, fn, wait = 400) {
    if (!this._debounceTimers) this._debounceTimers = {};
    if (this._debounceTimers[key]) clearTimeout(this._debounceTimers[key]);
    this._debounceTimers[key] = setTimeout(() => { fn(); delete this._debounceTimers[key]; }, wait);
  }

  openModal(modalKey, extraState = {}) {
    if (!modalKey) return;
    this.setState({ ...extraState, [modalKey]: true });
  }

  closeModal(modalKey, extraState = {}) {
    if (!modalKey) return;
    this.setState({ ...extraState, [modalKey]: false });
  }

  showTooltip(targetId, data) {
    try {
      const el = document.getElementById(targetId);
      if (!el) return;
    } catch (e) { return; }
    this.setState({ tooltipTarget: targetId, tooltipData: data, tooltipOpen: true });
  }

  hideTooltip() {
    this.setState({ tooltipOpen: false, tooltipTarget: null, tooltipData: null });
  }

  _cacheGet(map, key, ttlMs) {
    if (!map) return null;
    const entry = map.get(key);
    if (!entry) return null;
    if ((Date.now() - entry.time) > ttlMs) { map.delete(key); return null; }
    return entry.data;
  }

  _cacheSet(map, key, data) {
    map.set(key, { time: Date.now(), data });
  }

    
 

    //Para pequisar o usuário

    async addUserCompany(id){ 
      this.setState({ addUserCompany: true, editCompany: id });
    }



    // Para abrir o modal de remoção da unidade
    async deleteCompany(id){
      this.openModal('openDialogRemoveCompnay', { removeCompany: id });
    }

    // abrir modal de edição: agora modal carrega os dados
    editCompany(id){
      this.setState({ erroCompany: "", editCompany: id });
      this.openModal('openDialogCompanyCreate');
    }

    // abrir modal de criação
    newCompany(){
      this.setState({ erroCompany: "", editCompany: "" });
      this.openModal('openDialogCompanyCreate');
    }



    //Para pegar todas turmdas do sistema
    async getAllcompany(){

    var company = await this.helper.company().getListCompany();

    if(company.status === 200){

      // seta lista básica imediatamente para renderizar a UI rápido
      const companies = company.data || [];
      this.setState({companys: companies, companysVersion: (this.state.companysVersion || 0) + 1});

          // utilitário: controla a concorrência para evitar sobrecarga e travamentos
          const mapWithConcurrency = async (items, limit, mapper) => {
            const results = new Array(items.length);
            let inFlight = 0;
            let index = 0;
            return await new Promise((resolve, reject) => {
              const next = () => {
                if (index >= items.length && inFlight === 0) return resolve(results);
                while (inFlight < limit && index < items.length) {
                  const cur = index++;
                  inFlight++;
                  Promise.resolve(mapper(items[cur], cur))
                    .then(res => { results[cur] = res; })
                    .catch(err => { results[cur] = null; console.error('Erro no carregamento da unidade', err); })
                    .finally(() => { inFlight--; next(); });
                }
              };
              next();
            });
      };

      const promisesMapper = async (comp) => {
        try {
          // se tivermos cache para essa unidade, use imediatamente e não processe de novo
          if (this._companyCourseCache && this._companyCourseCache.has(String(comp.id))) {
            const cached = this._companyCourseCache.get(String(comp.id));
            this.setState({ courseDetails: cached, courseDetailsLoading: false });
            // segue para buscar contagens mesmo assim (cache é só de cursos)
          }
          const [usersResp, classResp, managersResp] = await Promise.all([
            this.helper.company().getUsersCompany(comp.id),
            this.helper.company().getClassRoomCompany(comp.id),
            this.helper.company().searchManagersCompanyAll(comp.id)
          ]);

          const users = (usersResp && usersResp.data) ? usersResp.data : [];
          const classrooms = (classResp && classResp.data) ? classResp.data : [];
          const managers = (managersResp && managersResp.data) ? managersResp.data : [];

          // pré-calcula agregados para evitar filtros pesados a cada render
          const now = new Date();
          const totalActiveStudents = users.filter(u => u.blocked === 0 && u.accessLevel === 4).length;
          const totalActiveInstructors = users.filter(u => u.blocked === 0 && u.accessLevel === 3).length;
          const totalActiveDirectors = users.filter(u => u.blocked === 0 && u.accessLevel === 5).length;
          const totalBlockedStudents = users.filter(u => u.blocked === 1 && u.accessLevel === 4).length;
          const totalBlockedInstructors = users.filter(u => u.blocked === 1 && u.accessLevel === 3).length;
          const totalBlockedDirectors = users.filter(u => u.blocked === 1 && u.accessLevel === 5).length;

          const totalActiveClassrooms = classrooms.filter(c => {
            const openingDate = new Date(c.openingDate);
            const closingDate = new Date(c.closingDate);
            return openingDate <= now && now <= closingDate;
          }).length;

          const totalCoursesTaught = new Set(classrooms.filter(c => {
            const openingDate = new Date(c.openingDate);
            const closingDate = new Date(c.closingDate);
            return openingDate <= now && now <= closingDate;
          }).map(c => c.course)).size;

          // Guarda somente contagens e agregados (economiza memória/renders)
          return Object.assign({}, comp, {
            usersCount: users.length,
            classroomsCount: classrooms.length,
            managersCount: managers.length,
            _aggregates: {
              totalActiveStudents,
              totalActiveInstructors,
              totalActiveDirectors,
              totalBlockedStudents,
              totalBlockedInstructors,
              totalBlockedDirectors,
              totalActiveClassrooms,
              totalCoursesTaught
            }
          });
        } catch (err) {
          // retorna objeto mínimo da unidade em caso de erro
          return Object.assign({}, comp, { usersCount: 0, classroomsCount: 0, managersCount: 0, _aggregates: {} });
        }
      };

      mapWithConcurrency(companies, 6, promisesMapper)
        .then(detailed => {
          this.setState(prev => ({ companys: detailed, companysVersion: (prev.companysVersion || 0) + 1 }));
        })
        .catch(err => {
          console.error('Erro ao carregar detalhes das unidades:', err);
        });

    }

    }

  // memoized filter to avoid recomputing on every render
  _lastFilterInput = null;
  _lastFilterResult = null;
  getFilteredCompaniesMemo() {
    const term = (this.state.companySearch || "").trim().toLowerCase();
    const companies = this.state.companys || [];
  const key = term + '::' + companies.length + '::' + (this.state.companysVersion || 0);
    if (this._lastFilterInput === key && this._lastFilterResult) return this._lastFilterResult;
    const res = companies.filter(value => {
      if (!term) return true;
      const name = (value.name || "").toString().toLowerCase();
      const group = (value.groupname || "").toString().toLowerCase();
      return name.includes(term) || group.includes(term) || String(value.id) === term;
    });
    this._lastFilterInput = key;
    this._lastFilterResult = res;
    return res;
  }



    //para criar um novo usuario no sistem,
    async componentDidMount(){
        await this.getAllcompany();
    }
    
    //Para pegar os usuarios e as turmas
  async getDataUnidade(id) {
    try {
      const [getUsersCompany, getClassRoomCompany, getManagersCompany] = await Promise.all([
        this.helper.company().getUsersCompany(id),
        this.helper.company().getClassRoomCompany(id),
        this.helper.company().searchManagersCompanyAll(id)
      ]);

      // monta objeto atualizado da unidade
      const users = (getUsersCompany && getUsersCompany.data) ? getUsersCompany.data : [];
      const classrooms = (getClassRoomCompany && getClassRoomCompany.data) ? getClassRoomCompany.data : [];
      const managers = (getManagersCompany && getManagersCompany.data) ? getManagersCompany.data : [];

      const now = new Date();
      const totalActiveStudents = users.filter(u => u.blocked === 0 && u.accessLevel === 4).length;
      const totalActiveInstructors = users.filter(u => u.blocked === 0 && u.accessLevel === 3).length;
      const totalActiveDirectors = users.filter(u => u.blocked === 0 && u.accessLevel === 5).length;
      const totalBlockedStudents = users.filter(u => u.blocked === 1 && u.accessLevel === 4).length;
      const totalBlockedInstructors = users.filter(u => u.blocked === 1 && u.accessLevel === 3).length;
      const totalBlockedDirectors = users.filter(u => u.blocked === 1 && u.accessLevel === 5).length;

      const totalActiveClassrooms = classrooms.filter(c => {
        const openingDate = new Date(c.openingDate);
        const closingDate = new Date(c.closingDate);
        return openingDate <= now && now <= closingDate;
      }).length;

      const totalCoursesTaught = new Set(classrooms.filter(c => {
        const openingDate = new Date(c.openingDate);
        const closingDate = new Date(c.closingDate);
        return openingDate <= now && now <= closingDate;
      }).map(c => c.course)).size;

      const updated = (this.state.companys || []).map(cp => {
        if (String(cp.id) === String(id)) {
          return Object.assign({}, cp, {
            usersCount: users.length,
            classroomsCount: classrooms.length,
            managersCount: managers.length,
            _aggregates: {
            totalActiveStudents,
            totalActiveInstructors,
            totalActiveDirectors,
            totalBlockedStudents,
            totalBlockedInstructors,
            totalBlockedDirectors,
            totalActiveClassrooms,
            totalCoursesTaught
          }});
        }
        return cp;
      });

  this.setState(prev => ({ companys: updated, companysVersion: (prev.companysVersion || 0) + 1 }));
      return true;
    } catch (error) {
      console.error(`Error fetching data for company ${id}:`, error);
      return false;
    }
    }

    openCourseModal = (company) => {
        // apenas abre o modal e define a unidade selecionada; modal carrega os dados por conta própria
        if (!company || (company && (company.id === undefined || company.id === null))) {
          console.warn('openCourseModal chamado sem company válido', company);
          try {
            this.refs.notificationAlert && this.refs.notificationAlert.notificationAlert({
              place: 'tr',
              message: (<div className="alert-text"><span className="alert-title">Aviso</span><span>Não foi possível abrir o relatório: unidade inválida.</span></div>),
              type: 'warning', icon: 'ni ni-bell-55', autoDismiss: 5
            });
          } catch (e) {}
          return;
        }

        this.setState({ coursesModalOpen: true, selectedCompany: company });
    };
      
      closeCourseModal = () => {
        this.setState({ coursesModalOpen: false, selectedCompany: null });
      };

      openAllCoursesModal = () => {
        // AllCoursesModal irá carregar os dados internamente quando aberto
        this.setState({ allCoursesModalOpen: true });
      };
      
      closeAllCoursesModal = () => {
        this.setState({ allCoursesModalOpen: false });
      };
      
      // Reutilizável: abre modal de unidades para um curso (usa state.unitsModalOpen já presente)
      openUnitsUsingCourse = (course) => {
        this.setState({ unitsModalOpen: true, unitsModalCourse: course });
      };

    // abre detalhes do curso (turmas + alunos únicos)
    openCourseDetails = async (courseId, courseName, backTarget = null) => {
        this.setState({
          courseDetailModalOpen: true,
          courseDetailLoading: true,
          courseStatsId: courseId,
      courseStatsName: courseName || "",
      // define alvo do botão Voltar (courses | units | allCourses)
      courseDetailBackTarget: backTarget
        });

        try {
          const resp = await api.getCourseClasses(courseId, this.state.selectedCompany?.id);
          const payload = resp && resp.data ? resp.data : {};
          const classes = Array.isArray(payload.classes) ? payload.classes : [];
          const students = Array.isArray(payload.students) ? payload.students : [];

          // normaliza alguns campos numéricos usados pela UI
          classes.forEach(c => {
            c.countStudents = Number(c.countStudents) || Number(c.countParticipants) || 0;
            c.countTeachers = Number(c.countTeachers) || 0;
            c.countAdmins = Number(c.countAdmins) || 0;
            c.countParticipants = Number(c.countParticipants) || 0;
            c.countActive = Number(c.countActive) || 0;
            c.countInactive = Number(c.countInactive) || 0;
            c.units = Array.isArray(c.units) ? c.units : [];
            // preencher nome da unidade quando tivermos o id
            try {
              if (c.company) {
                const cp = (this.state.companys || []).find(x => String(x.id) === String(c.company));
                c.companyName = cp ? (cp.name || `Unidade #${c.company}`) : `Unidade #${c.company}`;
              }
            } catch(e) {}
          });

            this.setState({
              courseDetailData: {
              course: courseId,
              courseName: courseName || "",
              classes,
              students
            },
            courseDetailLoading: false,
            courseDetailShowStudents: false
          });
        } catch (err) {
          console.error("Erro ao carregar detalhes do curso:", err);
          this.setState({ courseDetailLoading: false });
          this.refs.notificationAlert.notificationAlert({
            place: "tr",
            message: (<div className="alert-text"><span className="alert-title" data-notify="title">Erro</span><span data-notify="message">Não foi possível carregar os detalhes do curso.</span></div>),
            type: "danger", icon: "fas fa-exclamation", autoDismiss: 7
          });
        }
      };

      // Abre detalhes do curso filtrando por uma unidade (company)
    openCourseDetailsForUnit = async (courseId, companyId, courseName = "", companyName = "") => {
        // fechar modal de units para focar no detalhe
        this.setState({ unitsModalOpen: false });

        this.setState({
          courseDetailModalOpen: true,
          courseDetailLoading: true,
          courseStatsId: courseId,
          courseStatsName: courseName || "",
      selectedCompany: this.state.selectedCompany,
      // ao abrir a partir das unidades, o voltar retorna para UnitsModal
      courseDetailBackTarget: 'units'
        });

        try {
          const resp = await api.getCourseClasses(courseId, companyId);
          const payload = resp && resp.data ? resp.data : {};
          const classes = Array.isArray(payload.classes) ? payload.classes : [];
          const students = Array.isArray(payload.students) ? payload.students : [];

          // normaliza alguns campos numéricos usados pela UI
          classes.forEach(c => {
            c.countStudents = Number(c.countStudents) || Number(c.countParticipants) || 0;
            c.countTeachers = Number(c.countTeachers) || 0;
            c.countAdmins = Number(c.countAdmins) || 0;
            c.countParticipants = Number(c.countParticipants) || 0;
            c.countActive = Number(c.countActive) || 0;
            c.countInactive = Number(c.countInactive) || 0;
            c.units = Array.isArray(c.units) ? c.units : [];
            // preencher nome da unidade quando tivermos o id
            try {
              if (c.company) {
                const cp = (this.state.companys || []).find(x => String(x.id) === String(c.company));
                c.companyName = cp ? (cp.name || `Unidade #${c.company}`) : `Unidade #${c.company}`;
              }
            } catch(e) {}
          });

          this.setState({
            courseDetailData: {
              course: courseId,
              courseName: courseName || "",
              companyId: companyId,
              companyName: companyName || "",
              classes,
              students
            },
            courseDetailLoading: false,
            courseDetailShowStudents: false
          });
        } catch (err) {
          console.error("Erro ao carregar detalhes do curso para unidade:", err);
          this.setState({ courseDetailLoading: false });
          this.refs.notificationAlert.notificationAlert({
            place: "tr",
            message: (<div className="alert-text"><span className="alert-title" data-notify="title">Erro</span><span data-notify="message">Não foi possível carregar as turmas deste curso na unidade selecionada.</span></div>),
            type: "danger", icon: "fas fa-exclamation", autoDismiss: 7
          });
        }
      };

      // carrega participantes de uma turma (botão "Ver participantes")
      loadClassParticipants = async (classroomId) => {
        this.setState(prev => ({ classParticipantsLoading: { ...(prev.classParticipantsLoading || {}), [classroomId]: true } }));
        try {
          // Preferir endpoint que retorna todos os usuários com papel na turma (classRole)
          let users = [];
          try {
            const respAll = await api.getClassroomUsersAll(classroomId);
            users = Array.isArray(respAll?.data) ? respAll.data : [];
          } catch (e) {
            // Fallback para a rota antiga caso a nova não esteja disponível
            const resp = await api.searchUserClassRoom(classroomId);
            users = resp && Array.isArray(resp.data) ? resp.data : [];
          }

          // normaliza e adiciona rótulos de papel quando possível
          const normalizeRole = (u) => {
            // Pode vir como classRole (string/numero) ou cair no accessLevel
            const raw = (u.classRole !== undefined && u.classRole !== null) ? u.classRole : u.accessLevel;
            if (raw === undefined || raw === null) return '';
            const s = String(raw).toLowerCase();
            if (s === '6' || s === 'admin' || s === 'administrator') return 'admin';
            if (s === '3' || s === 'teacher' || s === 'instrutor' || s === 'instructor') return 'teacher';
            if (s === '4' || s === 'student' || s === 'aluno') return 'student';
            return '';
          };
          const labelFromNorm = (norm) => {
            if (norm === 'admin') return 'Admin';
            if (norm === 'teacher') return 'Instrutor';
            if (norm === 'student') return 'Aluno';
            return '';
          };
          users = users.map(u => {
            const _roleNorm = normalizeRole(u);
            const _roleLabel = labelFromNorm(_roleNorm);
            return { ...u, _roleNorm, _roleLabel };
          });

          this.setState(prev => ({
            classParticipants: { ...(prev.classParticipants || {}), [classroomId]: users },
            classParticipantsLoading: { ...(prev.classParticipantsLoading || {}), [classroomId]: false }
          }));
        } catch (err) {
          console.error("Erro ao carregar participantes da turma:", err);
          this.setState(prev => ({ classParticipantsLoading: { ...(prev.classParticipantsLoading || {}), [classroomId]: false } }));
          this.refs.notificationAlert.notificationAlert({
            place: "tr",
            message: (<div className="alert-text"><span className="alert-title" data-notify="title">Erro</span><span data-notify="message">Não foi possível carregar participantes da turma.</span></div>),
            type: "danger", icon: "fas fa-exclamation", autoDismiss: 7
          });
        }
      };

      openUserDetail = (user) => {
        if (!user) return;
        const id = (user && user.id) ? user.id : user;
        if (!id) return;
        this.setState({ userDetailModalOpen: true, userDetailId: id });
      }

      closeUserDetail = () => {
        this.setState({ userDetailModalOpen: false, userDetailId: null });
      }
  render(){

    return(
      <React.Fragment>
        <div className="rna-wrapper"><NotificationAlert ref="notificationAlert" /></div>
        <SimpleHeader name={this.props.translate['unidades']} way={[{name:this.props.translate['unidades'],url:"/company"}]} buttons={<React.Fragment></React.Fragment>} />
        <Container className="mt--6" fluid>
          <Card>
            <CardHeader className="border-0">
              <Row>
                <Col xs="6">
                  <h3 className="mb-0">
                    {this.props.translate['lista_de_unidades']}
                    {this.state.companys.length > 0 && (
                      <span className="ml-2 text-muted" style={{ fontSize: '1rem' }}>
                        ({this.state.companys.length})
                      </span>
                    )}
                  </h3>
                </Col>
                {
                  (this.props.permission.indexOf(26) !== -1) &&
                  <React.Fragment>
                  <Col className="text-right" xs="6">
                    <Button className="btn-neutral btn-round btn-icon mr-2" color="info" onClick={() => this.openAllCoursesModal()} size="sm">
                      <span className="btn-inner--icon mr-1"><i className="fas fa-chart-bar"></i></span>
                      <span className="btn-inner--text">{this.props.translate['relatorio_cursos']}</span>
                    </Button>
                    <Button className="btn-neutral btn-round btn-icon" color="default" onClick={() => this.newCompany()} size="sm">
                      <span className="btn-inner--icon mr-1"><i className="fas fa-plus"></i></span>
                      <span className="btn-inner--text">{this.props.translate['criar_unidade']}</span>
                    </Button>
                  </Col>
                  </React.Fragment>
                }
              </Row>
            </CardHeader>

            <div>
              <div style={{marginTop:'10px'}} id="datatable-basic_filter" className="dataTables_filter px-4 pb-1">
                <label>{this.props.translate['procurar']}:
          <input
                    type="text"
                    className="form-control form-control-sm"
                    value={this.state.companySearchInput}
                    onChange={(event) => {
                      const v = event.target.value || "";
                      // atualiza o input visível imediatamente
            this.setState({ companySearchInput: v, isTyping: true });
                      // comita o termo de busca com debounce para evitar re-renders intensos
            this.debounce('companySearchCommit', () => this.setState({ companySearch: v }), 300);
            // marca que o usuário parou de digitar após um pequeno intervalo
            this.debounce('typingStop', () => this.setState({ isTyping: false }), 400);
                    }}
                  />
                </label>
              </div>
            </div>

            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th>id</th>
                  <th>{this.props.translate['nome']}</th>
                  <th>{this.props.translate['grupo']}</th>
                  <th>Licença</th>
                  <th><center>{this.props.translate['limite_de_usuarios'] || 'Limite de usuários'}</center></th>
                  <th><center>{this.props.translate['usuarios']}</center></th>
                  <th><center>{this.props.translate['turmas']}</center></th>
                  <th><center>{this.props.translate['gestores']}</center></th>
                  <th>{this.props.translate['acoes']}</th>
                </tr>
              </thead>
              <tbody>
              {
                // use the memoized filter to avoid recomputation on each render
                (() => {
                  const filtered = this.getFilteredCompaniesMemo();
                  // Paginação removida: ao digitar, limitamos temporariamente o número de itens renderizados
                  // para evitar picos de render; caso contrário renderizamos todos os itens filtrados.
                  const pageItems = this.state.isTyping ? (filtered && filtered.slice ? filtered.slice(0, 50) : []) : filtered;
                  return (pageItems || []).map((value, index) => {

                  const agg = value._aggregates || {};
                  const totalActiveStudents = agg.totalActiveStudents || (value.users ? value.users.filter(u => u.blocked === 0 && u.accessLevel === 4).length : 0);
                  const totalActiveInstructors = agg.totalActiveInstructors || (value.users ? value.users.filter(u => u.blocked === 0 && u.accessLevel === 3).length : 0);
                  const totalActiveDirectors = agg.totalActiveDirectors || (value.users ? value.users.filter(u => u.blocked === 0 && u.accessLevel === 5).length : 0);
                  const totalBlockedStudents = agg.totalBlockedStudents || (value.users ? value.users.filter(u => u.blocked === 1 && u.accessLevel === 4).length : 0);
                  const totalBlockedInstructors = agg.totalBlockedInstructors || (value.users ? value.users.filter(u => u.blocked === 1 && u.accessLevel === 3).length : 0);
                  const totalBlockedDirectors = agg.totalBlockedDirectors || (value.users ? value.users.filter(u => u.blocked === 1 && u.accessLevel === 5).length : 0);
                  const totalActiveClassrooms = agg.totalActiveClassrooms || (value.classrooms ? value.classrooms.filter(c => { const now = new Date(); const openingDate = new Date(c.openingDate); const closingDate = new Date(c.closingDate); return openingDate <= now && now <= closingDate; }).length : 0);
                  const totalCoursesTaught = agg.totalCoursesTaught || (value.classrooms ? new Set(value.classrooms.filter(c => { const now = new Date(); const openingDate = new Date(c.openingDate); const closingDate = new Date(c.closingDate); return openingDate <= now && now <= closingDate; }).map(c => c.course)).size : 0);

                  var key = "user_key_"+value.id;
                  var tooltip = "tooltip_user_key_"+value.id;
 
                  return(<tr key={key} data-id={value.id} className="companyTableRow">
                      <td>{value.id}</td>
                      <td>{value.name}</td>
                      <td>{value.groupname}</td>
                      <td>{value.license}</td>
                      <td>
                        <center>
                          {
                            (value.user_limit === null || value.user_limit === undefined || value.user_limit === "")
                              ? "Sem limite"
                              : value.user_limit
                          }
                        </center>
                      </td>
                      
                      <td>
                        <center
                          id={"tooltipUsers_" + value.id}
                          onMouseEnter={() => !this.state.isTyping && this.showTooltip(`tooltipUsers_${value.id}`, {
                            type: 'users',
                            totalActiveStudents,
                            totalActiveInstructors,
                            totalActiveDirectors,
                            totalBlockedStudents,
                            totalBlockedInstructors,
                            totalBlockedDirectors
                          })}
                          onMouseLeave={this.hideTooltip}
                        >
                            { (value.usersCount === undefined) && (<ClipLoader sizeUnit={"px"} size={15} color={'#adb5bd'} loading={true} />) }
                            { (value.usersCount !== undefined) && (<center>{value.usersCount}</center>) }
                        </center>
                      </td>
                      <td>
                        <center
                          id={"tooltipTurmas_" + value.id}
                          onMouseEnter={() => !this.state.isTyping && this.showTooltip(`tooltipTurmas_${value.id}`, {
                            type: 'classes',
                            totalActiveClassrooms,
                            totalCoursesTaught
                          })}
                          onMouseLeave={this.hideTooltip}
                        >
                            { (value.classroomsCount === undefined) && (<ClipLoader sizeUnit={"px"} size={15} color={'#adb5bd'} loading={true} />) }
                            { (value.classroomsCount !== undefined) && (<center>{value.classroomsCount}</center>) }
                        </center>
                      </td>
                      <td>
                        <center>
                            { (value.managersCount === undefined) && (<ClipLoader sizeUnit={"px"} size={15} color={'#adb5bd'} loading={true} />) }
                            { (value.managersCount !== undefined) && (<center>{value.managersCount}</center>) }
                        </center>
                      </td> 
                      <td className="table-actions">
                        
                        <font
                          style={{cursor:"pointer"}}
                          onClick={() => this.editCompany(value.id)}
                          className="table-action"
                          id={tooltip}
                          onMouseEnter={() => this.showTooltip(tooltip, this.props.translate['editar_unidade'])}
                          onMouseLeave={this.hideTooltip}
                        >
                          <i className="far fa-edit"></i>
                        </font>

                        <font
                          style={{cursor:"pointer"}}
                          onClick={() => this.addUserCompany(value.id)}
                          className="table-action"
                          id={tooltip+"aa"}
                          onMouseEnter={() => this.showTooltip(tooltip+"aa", this.props.translate['gestores_da_unidade'])}
                          onMouseLeave={this.hideTooltip}
                        >
                          <i className="fas fa-users"></i>
                        </font>

                        <font
                          style={{cursor:"pointer"}}
                          onClick={() => this.openCourseModal(value)}
                          className="table-action"
                          id={tooltip+"courses"}
                          onMouseEnter={() => this.showTooltip(tooltip+"courses", 'Visualizar Cursos')}
                          onMouseLeave={this.hideTooltip}
                        >
                          <i className="fas fa-book"></i>
                        </font>

                        <font
                          style={{cursor:"pointer"}}
                          onClick={() => this.deleteCompany(value.id)}
                          className="table-action"
                          id={tooltip+"qr_code"}
                          onMouseEnter={() => this.showTooltip(tooltip+"qr_code", this.props.translate['remover_unidade'])}
                          onMouseLeave={this.hideTooltip}
                        >
                          <i className="far fa-trash-alt"></i>
                        </font>
                            
                      </td>
                    </tr>)

                  });
                  })()}

              </tbody>
            </Table>
              {this.state.tooltipData && (
                <Tooltip
                  autohide={false}
                  placement="right"
                  isOpen={this.state.tooltipOpen}
                  target={this.state.tooltipTarget}
                  toggle={this.hideTooltip}
                >
                  <div style={{ maxWidth: '300px', textAlign: 'left' }}>
                    {typeof this.state.tooltipData === 'string' && (
                      <span>{this.state.tooltipData}</span>
                    )}
                    {typeof this.state.tooltipData === 'object' && this.state.tooltipData.type === 'users' && (
                      <div>
                        Usuários ativos:
                        <br />Alunos: {this.state.tooltipData.totalActiveStudents}
                        <br />Instrutores: {this.state.tooltipData.totalActiveInstructors}
                        <br />Diretores: {this.state.tooltipData.totalActiveDirectors}
                        <br />
                        <br />Usuários bloqueados:
                        <br />Alunos: {this.state.tooltipData.totalBlockedStudents}
                        <br />Instrutores: {this.state.tooltipData.totalBlockedInstructors}
                        <br />Diretores: {this.state.tooltipData.totalBlockedDirectors}
                        <br />
                        <br />
                        <i style={{ fontSize: '0.8em' }}>Obs: essa contagem não inclui administradores</i>
                      </div>
                    )}
                    {typeof this.state.tooltipData === 'object' && this.state.tooltipData.type === 'classes' && (
                      <div>
                        Número de turmas ativas: {this.state.tooltipData.totalActiveClassrooms}
                        <br />Cursos lecionados ativos: {this.state.tooltipData.totalCoursesTaught}
                      </div>
                    )}
                  </div>
                </Tooltip>
              )}
            {

                (this.state.companys.length === 0) &&
                <center><h3 style={{margin:'30px 0px'}}>{this.props.translate['nenhuma_unidade_foi_encontrada']}</h3></center>
                
            }
            {/* Paginação removida: a lista completa (filtrada) é exibida acima. */}
          </Card>
        </Container>

  <RemoveCompanyModal
    isOpen={this.state.openDialogRemoveCompnay}
    openModal={this.state.openDialogRemoveCompnay}
    toggle={() => this.setState({ openDialogRemoveCompnay: false, removeCompany: null })}
    companyId={this.state.removeCompany}
    onRemoved={async () => { this.setState({ openDialogRemoveCompnay: false, removeCompany: null }); await this.getAllcompany(); }}
    notify={(opts) => { try { this.refs.notificationAlert && this.refs.notificationAlert.notificationAlert(opts); } catch (e) { console.log('notification error', e); } }}
  />

        <CompanyCreateModal
          isOpen={this.state.openDialogCompanyCreate}
          openModal={this.state.openDialogCompanyCreate}
          toggle={() => this.closeModal('openDialogCompanyCreate')}
          companyId={this.state.editCompany}
          onSaved={async () => { this.setState({ openDialogCompanyCreate: false, editCompany: null }); await this.getAllcompany(); }}
          notify={(opts) => { try { this.refs.notificationAlert && this.refs.notificationAlert.notificationAlert(opts); } catch(e) { console.log('notification error', e); } }}
        />

        <AddUserCompanyModal
          isOpen={this.state.addUserCompany}
          openModal={this.state.addUserCompany}
          toggle={() => this.closeModal('addUserCompany')}
          companyId={this.state.editCompany}
          onChanged={async () => { await this.getDataUnidade(this.state.editCompany); }}
          notify={(opts) => { try { this.refs.notificationAlert.notificationAlert(opts); } catch(e) { console.log('notification error', e); } }}
        />

          {this.state.coursesModalOpen && (
            <CompanyCoursesModal
              isOpen={this.state.coursesModalOpen}
              openModal={this.state.coursesModalOpen}
              toggle={this.closeCourseModal}
              company={this.state.selectedCompany}
              onOpenDetails={(id, name) => this.openCourseDetails(id, name, 'courses')}
              onBack={() => this.setState({ coursesModalOpen: false })}
            />
          )}

        {this.state.courseDetailModalOpen && (
          <CourseDetailModal
            isOpen={this.state.courseDetailModalOpen}
            openModal={this.state.courseDetailModalOpen}
            toggle={() => this.setState({ courseDetailModalOpen: false, courseDetailData: null, courseDetailShowStudents: false })}
            loading={this.state.courseDetailLoading}
            data={this.state.courseDetailData}
            showStudents={this.state.courseDetailShowStudents}
            onToggleShowStudents={() => this.setState(prev => ({ courseDetailShowStudents: !prev.courseDetailShowStudents }))}
            onRefresh={() => {  
              this.setState({ courseDetailData: null });
              this.openCourseDetails(this.state.courseStatsId || (this.state.courseDetailData && this.state.courseDetailData.course), this.state.courseDetailData?.courseName);
            }}
            onOpenClassroom={(id) => this.props.history.push('/myclassroom/' + id)}
            onLoadParticipants={this.loadClassParticipants}
            classParticipants={this.state.classParticipants}
            classParticipantsLoading={this.state.classParticipantsLoading}
            onShowUserDetail={this.openUserDetail}
            onBack={() => {
              const target = this.state.courseDetailBackTarget;
              if (target === 'units') {
                this.setState({ courseDetailModalOpen: false, unitsModalOpen: true });
              } else if (target === 'courses') {
                this.setState({ courseDetailModalOpen: false });
              } else if (target === 'allCourses') {
                this.setState({ courseDetailModalOpen: false, allCoursesModalOpen: true });
              } else {
                this.setState({ courseDetailModalOpen: false });
              }
            }}
          />
        )}

        {this.state.allCoursesModalOpen && (
          <AllCoursesModal
            isOpen={this.state.allCoursesModalOpen}
            openModal={this.state.allCoursesModalOpen}
            toggle={this.closeAllCoursesModal}
            onOpenUnits={(c) => this.openUnitsUsingCourse(c)}
            onOpenDetails={(courseObj) => { 
              if (!courseObj) return;
              const num = Number(courseObj.id);
              if (Number.isNaN(num)) return; 
              this.setState({ 
                allCoursesModalOpen: false,
                courseDetailModalOpen: true,
                courseDetailLoading: true,
                courseDetailData: { course: num, courseName: courseObj.name || '' },
                courseDetailBackTarget: 'allCourses',
                courseStatsId: num,
                courseStatsName: courseObj.name || ''
              }, () => {
                this.openCourseDetails(num, courseObj.name || '', 'allCourses');
              }); 
            }}
            onBack={() => this.setState({ allCoursesModalOpen: false })}
          />
        )}

{/* Reutiliza unitsModal existente para mostrar unidades de um curso (se já não existir, criamos abaixo) */}
        {this.state.unitsModalOpen && (
          <UnitsModal
            isOpen={this.state.unitsModalOpen}
            openModal={this.state.unitsModalOpen}
            toggle={() => this.setState({ unitsModalOpen: false, unitsModalCourse: null })}
            course={this.state.unitsModalCourse}
            onOpenCourseForUnit={(courseId, unitId, courseName, unitName) => this.openCourseDetailsForUnit(courseId, unitId, courseName, unitName)}
            onBack={() => this.setState({ unitsModalOpen: false })}
          />
        )}

      {/* Modal: Detalhe reduzido do usuário (privacidade preservada) */}
  <UserDetailModal isOpen={this.state.userDetailModalOpen} toggle={this.closeUserDetail} userId={this.state.userDetailId} onBack={() => this.setState({ userDetailModalOpen: false, userDetailId: null })} />
      </React.Fragment>
    );
  }
}

export default connect(state =>({

  languages: state.language,
  translate: state.translate,
  accesslevel: state.accesslevel,
  permission: state.permission,
  user: state.user,

}))(Users);